import React, { FC } from 'react'
import { styled } from '@creditas/stylitas'
import ContentLoader from 'react-content-loader'

const Paragraph = styled.p`
  margin-left: -4px;
`

const UpsellContentFetching: FC = () => (
  <Paragraph>
    <ContentLoader height={14} width={200}>
      <rect x="0" y="0" rx="8" ry="8" width="200" height="14" />
    </ContentLoader>
  </Paragraph>
)

export { UpsellContentFetching }
